/* import __COLOCATED_TEMPLATE__ from './react-bridge-with-providers.hbs'; */
import ReactBridge from '@qonto/react-migration-toolkit/components/react-bridge';
import { CustomProviders } from '../react/contexts/react-bridge/custom-providers';

export default class ReactBridgeWithProviders<
  T extends keyof HTMLElementTagNameMap, // we only want to allow valid HTML tag names
  R,
> extends ReactBridge<T, R> {
  customProvidersComponent = CustomProviders;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    ReactBridgeWithProviders: typeof ReactBridgeWithProviders;
  }
}
